import React, { useEffect } from 'react';
import { Form, Field } from 'react-final-form';
import { Link, useHistory } from 'react-router-dom';

import logo from 'modules/ui/assets/images/logo.png';
import { TextInput, Button, InputError } from 'modules/ui/components';
import { HighlightedSm, RegularSm } from 'modules/ui/typography';
import { Routes } from 'Routes';
import { validatePassword, validateRepeatedPassword } from 'modules/form';
import { AuthImageContainer } from '../../components';
import { useConfirmPasswordChange } from '../../hooks';
import {
  FormContainer,
  LogoImage,
  Title,
  LinksContainer,
} from './styledComponents';

const ResetPasswordPageUi: React.FC = () => {
  const { error, success, loading, handleConfirmPasswordChange } =
    useConfirmPasswordChange();
  const history = useHistory();

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => history.push(Routes.Login), 3000);
      return () => clearTimeout(timer);
    }
  }, [success, history]);

  return (
    <AuthImageContainer>
      <FormContainer>
        <LogoImage src={logo} alt="Dorado sail" />
        <Title>Reset password</Title>
        <Form
          onSubmit={handleConfirmPasswordChange}
          initialValues={{ password: '', repeatedPassword: '' }}
          render={({ handleSubmit, invalid }): React.ReactNode => (
            <form>
              <div className="field-container">
                <Field
                  name="password"
                  type="password"
                  component={TextInput}
                  width={320}
                  label="New password"
                  validate={validatePassword}
                />
              </div>
              <div className="field-container">
                <Field
                  name="repeatedPassword"
                  type="password"
                  component={TextInput}
                  width={320}
                  label="Repeat new password"
                  validate={validateRepeatedPassword}
                />
              </div>
              {error !== null && <InputError>{error}</InputError>}
              {success && (
                <RegularSm>
                  Your password has been changed successfully.
                </RegularSm>
              )}
              <Button
                disabled={invalid || success}
                stretch
                label="Set new password"
                isLoading={loading}
                clickHandler={handleSubmit}
                type="submit"
              />
              <LinksContainer>
                <RegularSm>
                  <Link to={Routes.Login}>
                    <HighlightedSm>Back to login</HighlightedSm>
                  </Link>
                </RegularSm>
              </LinksContainer>
            </form>
          )}
        />
      </FormContainer>
    </AuthImageContainer>
  );
};

export const ResetPasswordPage = React.memo(ResetPasswordPageUi);
